import {PlayParticipantsContainerController} from "./PlayParticipantsContainer";


export class ToggleButtonController {
    public sorting: any;
    public type: string;
    public toggleSort: any;
    public app: PlayParticipantsContainerController;

    /**
     * Toggle sort state of this button.
     */
    public toggle() {
        const order = this.sorting.order === "asc" ? "desc" : "asc";
        this.app.setSorting(this.type, order);
    }
}